import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import '../utils/Clientes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPenToSquare} from '@fortawesome/free-solid-svg-icons';

//const API_URL_CLIENTES = 'http://localhost:4000/clientes';
//const API_URL_CLIENTES = process.env.REACT_APP_API_URL + '/clientes';

const API_URL_CLIENTES = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/clientes` 
  : 'http://localhost:4000/clientes';

  const Clientes = () => {
  const [clientes, setClientes] = useState([]);
  const [searchCode, setSearchCode] = useState('');
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newCliente, setNewCliente] = useState({
    nombre_cliente: '',
    codigo_cliente: '',
    direccion_cliente: '',
    telefono_cliente: '',
    email_cliente: '',
    fecha_registro: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [existsError, setExistsError] = useState('');
  const [clientSearch, setClientSearch] = useState('');
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    fetchClientes();
  }, []);

  useEffect(() => {
    if (searchCode) {
      fetchClienteByCode(searchCode);
    } else {
      fetchClientes();
    }
  }, [searchCode]);

  const fetchClientes = async () => {
    try {
      const response = await axios.get(API_URL_CLIENTES);
      // Ordenar los clientes por fecha_registro en orden descendente
      const sortedClientes = response.data.sort((a, b) => new Date(b.fecha_registro) - new Date(a.fecha_registro));
      setClientes(sortedClientes);
    } catch (error) {
      console.error('Error fetching clientes data:', error);
    }
  };
  

  const fetchClienteByCode = async (codigo) => {
    try {
      const response = await axios.get(`${API_URL_CLIENTES}/codigo/${codigo}`);
      setClientes([response.data]);
    } catch (error) {
      console.error('Error fetching cliente data:', error);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchCode) {
      fetchClienteByCode(searchCode);
    } else {
      fetchClientes();
    }
  };

  const handleDelete = (cliente) => {
    setSelectedCliente(cliente);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${API_URL_CLIENTES}/${selectedCliente.id_cliente}`);
      fetchClientes();
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error('Error deleting cliente:', error);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  const checkClienteExists = async (codigo) => {
    try {
      const response = await axios.get(`${API_URL_CLIENTES}/codigo/${codigo}`);
      return response.status === 200;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return false;
      }
      console.error('Error checking if cliente exists:', error);
      return false;
    }
  };

  const handleAddCliente = async (e) => {
    e.preventDefault();
    const { nombre_cliente, codigo_cliente, direccion_cliente, telefono_cliente, email_cliente, fecha_registro } = newCliente;

    if (!nombre_cliente || !codigo_cliente || !direccion_cliente || !telefono_cliente || !email_cliente || !fecha_registro) {
      setErrorMessage('Todos los campos son obligatorios.');
      return;
    }

    if (codigo_cliente.length !== 10 || isNaN(codigo_cliente)) {
      setErrorMessage('La cédula debe tener exactamente 10 dígitos.');
      return;
    }

    const exists = await checkClienteExists(codigo_cliente);
    if (exists) {
      setExistsError('Cliente ya existe registrado');
      return;
    }

    try {
      await axios.post(API_URL_CLIENTES, newCliente);
      fetchClientes();
      handleCloseModal();
    } catch (error) {
      console.error('Error adding cliente:', error);
      setErrorMessage('Error al agregar el cliente.');
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewCliente({
      nombre_cliente: '',
      codigo_cliente: '',
      direccion_cliente: '',
      telefono_cliente: '',
      email_cliente: '',
      fecha_registro: '',
    });
    setErrorMessage('');
    setExistsError('');
  };

  const handleOpenEditModal = (cliente) => {
    setSelectedCliente(cliente);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedCliente(null);
  };

  const handleUpdateCliente = async (e) => {
    e.preventDefault();
    if (!selectedCliente) return;

    try {
      await axios.put(`${API_URL_CLIENTES}/${selectedCliente.id_cliente}`, selectedCliente);
      fetchClientes();
      handleCloseEditModal();
    } catch (error) {
      console.error('Error updating cliente:', error);
      setErrorMessage('No se pudo actualizar el cliente.');
    }
  };

  const validateTelefono = (value) => {
    const phonePattern = /^[0-9]+$/; // Permite solo números
    return phonePattern.test(value);
  };
  const handleChangeTelefono = (e) => {
    const { value } = e.target;
    if (validateTelefono(value)) {
      setNewCliente({ ...newCliente, telefono_cliente: value });
      setErrorMessage('');
    } else {
      setErrorMessage('El teléfono debe contener solo números.');
    }
  };
    
  
  return (
    <div className="clientes-panel">
      <div className="header-buttons">
        <Button variant="primary" onClick={handleOpenModal}>+ Nuevo Cliente</Button>
      </div>

      <h2>Gestión de Clientes</h2>

      <Form onSubmit={handleSearch} className="search-form">
        <Form.Control
          type="text"
          value={searchCode}
          onChange={(e) => setSearchCode(e.target.value)}
          placeholder="Buscar por cédula del cliente"
        />
        <Button variant="secondary" type="submit">Buscar</Button>
      </Form>
      <div className="clientes-panel1"> 
      <table className="clientes-table">
        <thead>
          <tr>
            <th>Cédula</th>
            <th>Nombres y Apellidos</th>
            <th>Dirección</th>
            <th>Teléfono</th>
            <th>Correo electrónico</th>
            <th>Fecha Registro</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <tr key={cliente.codigo_cliente}>
              <td>{cliente.codigo_cliente}</td>
              <td>{cliente.nombre_cliente}</td>
              <td>{cliente.direccion_cliente}</td>
              <td>{cliente.telefono_cliente}</td>
              <td>{cliente.email_cliente}</td>
              <td>{new Date(cliente.fecha_registro).toLocaleDateString()}</td>
              <td className="button-container">
                <Button variant="success" className="action-button" onClick={() => handleOpenEditModal(cliente)}><FontAwesomeIcon icon={faPenToSquare} /></Button>
                <Button variant="danger" className="action-button delete-button" onClick={() => handleDelete(cliente)}><FontAwesomeIcon icon={faTrash} /></Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {/* Modal para agregar un nuevo cliente */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nuevo Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="alert alert-danger mt-3">
              {errorMessage}
            </div>
          )}
          {existsError && (
            <div className="alert alert-danger mt-3">
              {existsError}
            </div>
          )}
          <Form onSubmit={handleAddCliente} className="cliente-form">
            <Form.Group>
              <Form.Label>Nombre del Cliente</Form.Label>
              <Form.Control
                type="text"
                value={newCliente.nombre_cliente}
                onChange={(e) => setNewCliente({ ...newCliente, nombre_cliente: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Cédula del Cliente</Form.Label>
              <Form.Control
                type="text"
                value={newCliente.codigo_cliente}
                onChange={(e) => setNewCliente({ ...newCliente, codigo_cliente: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                type="text"
                value={newCliente.direccion_cliente}
                onChange={(e) => setNewCliente({ ...newCliente, direccion_cliente: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                value={newCliente.telefono_cliente}
                onChange={handleChangeTelefono}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={newCliente.email_cliente}
                onChange={(e) => setNewCliente({ ...newCliente, email_cliente: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Fecha de Registro</Form.Label>
              <Form.Control
                type="date"
                value={newCliente.fecha_registro}
                onChange={(e) => setNewCliente({ ...newCliente, fecha_registro: e.target.value })}
                required
              />
            </Form.Group> <br />
            <Button variant="primary" type="submit">Agregar</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal de confirmación de eliminación */}
      <Modal show={showDeleteConfirm} onHide={cancelDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Estás seguro de que deseas eliminar este cliente?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Eliminar</Button>
        </Modal.Footer>
      </Modal>


<Modal show={showEditModal} onHide={handleCloseEditModal}>
  <Modal.Header closeButton>
    <Modal.Title>Editar Cliente</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Mostrar mensajes de error */}
    {errorMessage && (
      <div className="alert alert-danger mt-3">
        {errorMessage}
      </div>
    )}

    <Form onSubmit={handleUpdateCliente} className="edit-client-form">
      <Form.Group>
        <Form.Label>Nombre del Cliente</Form.Label>
        <Form.Control
          type="text"
          value={selectedCliente?.nombre_cliente || ''}
          onChange={(e) => setSelectedCliente({ ...selectedCliente, nombre_cliente: e.target.value })}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Cédula del Cliente</Form.Label>
        <Form.Control
          type="text"
          value={selectedCliente?.codigo_cliente || ''}
          onChange={(e) => setSelectedCliente({ ...selectedCliente, codigo_cliente: e.target.value })}
          required
          disabled
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Dirección del Cliente</Form.Label>
        <Form.Control
          type="text"
          value={selectedCliente?.direccion_cliente || ''}
          onChange={(e) => setSelectedCliente({ ...selectedCliente, direccion_cliente: e.target.value })}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Teléfono del Cliente</Form.Label>
        <Form.Control
          type="text"
          value={selectedCliente?.telefono_cliente || ''}
          onChange={(e) => setSelectedCliente({ ...selectedCliente, telefono_cliente: e.target.value })}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Email del Cliente</Form.Label>
        <Form.Control
          type="email"
          value={selectedCliente?.email_cliente || ''}
          onChange={(e) => setSelectedCliente({ ...selectedCliente, email_cliente: e.target.value })}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Fecha de Registro</Form.Label>
        <Form.Control
          type="date"
          value={selectedCliente?.fecha_registro || ''}
          onChange={(e) => setSelectedCliente({ ...selectedCliente, fecha_registro: e.target.value })}
          required
        />
      </Form.Group>
      <Button variant="primary" type="submit">
        Guardar Cambios
      </Button>
    </Form>
  </Modal.Body>
</Modal>
    </div>
  );
};

export default Clientes;
